import React from 'react'
import './PageTitle.scss'

export default function PageTitle(props){
  const {
    text
  } = props


  return (
    <div style={{display: 'flex'}}>
      <h1 className='pageTitle'>{text}</h1>
    </div>
  )
}